import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { useRef, useState, useEffect } from 'react';

const useStyles = makeStyles(() => ({
  formControl: {
    minWidth: 120,
    width: '100%'
  },
  selectMenu: {
    width: '100%'
  },
  menuPaper: {
    maxHeight: 300
  },
  menuItem: {
    whiteSpace: 'normal',
    wordBreak: 'break-word'
  }
}));

function MUISelectControl({
  label,
  options = [],
  styles = { formControl: {} },
  ...props
}) {
  const classes = useStyles();
  const formControlRef = useRef(null);
  const [menuWidth, setMenuWidth] = useState(0);

  useEffect(() => {
    if (formControlRef.current) {
      setMenuWidth(formControlRef.current.clientWidth);
    }
  }, []);

  return (
    <FormControl
      variant="outlined"
      className={`${classes.formControl} ${styles.formControl.className || ''}`}
      style={styles.formControl.style || {}}
      ref={formControlRef}>
      <InputLabel shrink={props.shrink}>{label}</InputLabel>
      <Select
        {...props}
        label={label}
        MenuProps={{
          getContentAnchorEl: null,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left'
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left'
          },
          classes: {
            paper: classes.menuPaper
          },
          PaperProps: {
            style: {
              width: menuWidth > 0 ? menuWidth : undefined
            }
          },
          ...props.MenuProps
        }}
        className={classes.selectMenu}>
        {options.map((option) => (
          <MenuItem
            key={option.value}
            value={option.value}
            className={classes.menuItem}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default MUISelectControl;
